/**
 * The Zones section's routes. The two views are tabs, and so routes (CLAUDE.md → Tabs are routes):
 * `/zones/map` and `/zones/list`, with `/zones` redirecting to the map. A zone opens in the view it was
 * opened from: `/zones/:id` (and `/zones/new`) is the map with the zone's panel beside it, and
 * `/zones/list/:id` (and `/zones/list/new`) is the table with the zone in a wide sheet over it.
 */
export const ZONE_VIEWS = ['map', 'list'] as const;
export type ZoneView = (typeof ZONE_VIEWS)[number];

export const ZONE_VIEW_LABELS: Record<ZoneView, string> = { map: 'Map', list: 'Table' };

export const ZONES_PATH = '/zones';

export function zoneViewPath(view: ZoneView): string {
  return `${ZONES_PATH}/${view}`;
}

export function zonePath(id: string): string {
  return `${ZONES_PATH}/${id}`;
}

/** Where a zone opens from a view: beside the map, or in the table's sheet. */
export function zoneRecordPath(view: ZoneView, id: string): string {
  return view === 'list' ? `${zoneViewPath('list')}/${id}` : zonePath(id);
}

export function newZonePath(view: ZoneView): string {
  return zoneRecordPath(view, 'new');
}
